import React from 'react';
import IrrigationChart from '../../../../../../components/Highcharts/IrrigationChart/IrrigationChart';
import SoilMoistureChart from '../../../../../../components/Highcharts/LineCharts/SoilMoistureChart/SoilMoistureChart';
import PlantsChart from '../../../../../../components/Highcharts/LineCharts/PlantsChart/PlantsChart';
import useStyles from '../../../../../../components/Highcharts/styles';
import useResponsiveChartHeight from '../../../../../../hooks/useResponsiveChartHeight';
import DpvChart from '../../../../../../components/Highcharts/LineCharts/DpvChart/DpvChart';

function PlantDashboard({
  sectorId,
  farmId,
}: {
  sectorId: string,
  farmId: string,
}) {
  const classes = useStyles();
  const {
    smallChartHeight, mediumChartHeight, largeChartHeight, xLargeChartHeight,
  } = useResponsiveChartHeight();

  return (
    <div className={classes.dashboardContainer}>
      <IrrigationChart
        chartView="dashboard"
        hideLegend={false}
        hideYValues={false}
        hideXValues={true}
        sectorId={sectorId}
        farmId={farmId}
        height={smallChartHeight}
        yAxisTitle=""
        title="Kc y mm"
      />
      <DpvChart
        chartView="dashboard"
        hideLegend={false}
        hideYValues={false}
        hideXValues={true}
        sectorId={sectorId}
        farmId={farmId}
        height={mediumChartHeight}
        yAxisTitle=""
        title="DPV"
      />
      <PlantsChart
        chartView="dashboard"
        hideYValues={false}
        hideXValues={true}
        sectorId={sectorId}
        farmId={farmId}
        height={largeChartHeight}
        title="Dendrómetro de brote"
        yAxisTitle=" "
      />
      <SoilMoistureChart
        chartView="dashboard"
        hideYValues={false}
        hideXValues={false}
        hideLegend={true}
        sectorId={sectorId}
        farmId={farmId}
        height={xLargeChartHeight}
        title="Sumatoria humedad de suelo"
        yAxisTitle=" "
      />
    </div>
  );
}

export default PlantDashboard;
